export const constants = {
  permissions: [
    {
      PermissionId: '22',
      PermissionName: 'Personal Notes'
    },
    {
      PermissionId: '23',
      PermissionName: 'Edit Notes Dropdown'
    },
    {
      PermissionId: '24',
      PermissionName: 'Group Notes Email Alerts'
    },
    {
      PermissionId: '27',
      PermissionName: 'Legis: View'
    },
    {
      PermissionId: '28',
      PermissionName: 'Legis: View Group Notes'
    },
    {
      PermissionId: '29',
      PermissionName: 'Legis: Edit Group Notes'
    },
    {
      PermissionId: '30',
      PermissionName: 'Legis: Edit Subjects'
    },
    {
      PermissionId: '31',
      PermissionName: 'Legis: Delete Records'
    },
    {
      PermissionId: '32',
      PermissionName: 'Legis: Admin Subjects (Change, Add, Archive)'
    },
    {
      PermissionId: '38',
      PermissionName: 'Regs: View'
    },
    {
      PermissionId: '39',
      PermissionName: 'Regs: View Group Notes'
    },
    {
      PermissionId: '40',
      PermissionName: 'Regs: Edit Group Notes'
    },
    {
      PermissionId: '41',
      PermissionName: 'Regs: Edit Subjects'
    },
    {
      PermissionId: '42',
      PermissionName: 'Regs: Delete Records'
    },
    {
      PermissionId: '43',
      PermissionName: 'Regs: Add Regs'
    },
    {
      PermissionId: '48',
      PermissionName: 'Local: View'
    },
    {
      PermissionId: '49',
      PermissionName: 'Local: View Group Notes'
    },
    {
      PermissionId: '50',
      PermissionName: 'Local: Edit Group Notes'
    },
    {
      PermissionId: '51',
      PermissionName: 'Local: Edit Subjects'
    },
    {
      PermissionId: '52',
      PermissionName: 'Local: Delete Records'
    },
    {
      PermissionId: '56',
      PermissionName: 'Bill Finder: View Text Search'
    },
    {
      PermissionId: '57',
      PermissionName: 'Bill Finder: Add From Text Search'
    },
    {
      PermissionId: '59',
      PermissionName: 'Quick Links: View'
    },
    {
      PermissionId: '60',
      PermissionName: 'Quick Links: Admin Client Sharing'
    },
    {
      PermissionId: '61',
      PermissionName: 'Quick Links: Admin Group Notes Sharing'
    },
    {
      PermissionId: '62',
      PermissionName: 'Quick Links: Admin Public Links'
    },
    {
      PermissionId: '63',
      PermissionName: 'Quick Links: Show Only Quick Links'
    },
  ],
}



// WEBPACK FOOTER //
// ./src/components/ManagementUserList/constants.js